import React from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import './AboutUs.css';

const aboutUs = () => {
  return (
    <div className="about_us_wrpr" id="about-us">
      <h1 className="bf hdr mobile_only">About us</h1>

      <div className="df inner_wrpr">
        <div className="left_sec sec">
          <h1 className="bf mobile_hide">About us</h1>

          <p className="bslf txt">
            Omedia is a group of of collaborative talent that includes expert
            ui-ux web &amp; graphic designers and pixel perfect developers
            providing custom designed enterprise workflow software, mobile apps,
            websites, and digital &amp; print media solutions for small and
            midsize business. we take pride in what we do, in our ability to
            listen attentively, ask the right questions, place ourselves in the
            users shoes, and design exceptional cutting edge solutions for our
            clients.
          </p>

          <NavLink className="ttu bslf" smooth to="/#contact">
            Talk to an expert
          </NavLink>
        </div>
        <div className="df right_sec sec">
          <div className="img_wrpr">
            <div className="img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default aboutUs;



// WEBPACK FOOTER //
// ./src/components/about-us/AboutUs.js